import { t } from "../../services/utils";
import React from "react";
import { connect } from "react-redux";
import {
  primaryDark10,
  primaryDark60,
  grey600,
  blue700,
  primaryDark,
} from "../../constants/colors";
import {
  GET_CLIENTS,
  GET_NOTIFICATIONS,
  MARK_NOTIFICATION_READ,
} from "../../constants/action-types";
import notificationTypes from "../../constants/notificationTypes";
import storyTypes from "../../constants/storyTypes";
import ProfileImageView from "../../components/ProfileImageView";
import { SelectedBackgroundColor } from "../../constants/colors";
import _ from "lodash";
import { updateChatState } from "../../data/app/actions";
import channelTypes from "../../constants/channel-type";
import { sendInvite } from "../../data/user/api";
import { Button } from "@material-ui/core";
import { useLocation, useNavigate } from "react-router";
class NotificationsView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      initialNewNotificationCount: props.newNotificationsCount,
    };
  }
  componentDidMount = () => {
    if (
      this.props.notifications === null ||
      this.props.newNotificationsCount > 0
    ) {
      this.props.getNotifications();
    }
    if (!this.props.clients) {
      this.props.getClients();
    }
  };
  onNotificationClicked = (notification) => {
    this.props.recordReadNotification(notification);
    this.props.onNotificationClicked(notification);
    let nt = notification.notification_type;
    if (
      nt === notificationTypes.STORY_COMMENT_ADDED ||
      nt === notificationTypes.STORY_LIKED
    ) {
      this.props.loadStory(notification.meta.story_id, this.props.navigate);
    } else if (nt === notificationTypes.NEW_MESSAGE) {
      this.props.loadChat(notification.object_id_int);
    } else if (nt === notificationTypes.CLIENT_IGNORED_INVITE) {
      sendInvite(this.props.clients[notification.source_id]);
    } else if (nt === notificationTypes.CLIENT_FIRST_LOGIN) {
      if (notification.meta.waiting_for_workout_plan) {
        this.props.loadClient(notification.source_id, this.props.navigate);
      } else {
        this.props.loadChat(notification.source_id);
      }
    } else if (nt === notificationTypes.TEST_DRIVE_MOBILE_APP) {
      this.props.testDriveMobileApp(this.props.navigate);
    } else if (nt === notificationTypes.TEST_DRIVE_CLIENT_APP) {
      this.props.testDriveClientApp(this.props.navigate);
    } else if (nt === notificationTypes.NEW_CLIENT_SIGNUP) {
      this.props.loadChat(notification.source_id);
    } else if (nt === notificationTypes.TRAINERFU_ENGAGEMENT_MESSAGE) {
      let meta = notification.meta;
      window.open(meta.url, "_blank");
    } else if (nt === notificationTypes.GMAIL_API_TOKEN_EXPIRED) {
      this.props.goToIntegrationSettings(this.props.navigate);
    } else if (nt === notificationTypes.CLIENT_CANCELLED_SUBSCRIPTION) {
      this.props.goToClientSettings(
        notification.source_id,
        this.props.navigate,
      );
    } else if (nt === notificationTypes.PLAN_TEMPLATE_COPIED) {
      this.props.loadPlanTemplate(
        notification.object_id_int,
        this.props.navigate,
      );
    } else if (nt === notificationTypes.DELETE_CLIENT_ACCOUNT_REQUEST) {
      this.props.goToClientSettings(
        notification.object_id_int,
        this.props.navigate,
      );
    } else if (nt === notificationTypes.CLIENT_ACCOUNT_DEACTIVATED_IAP) {
      this.props.goToClientSettings(
        notification.object_id_int,
        this.props.navigate,
      );
    } else if (nt === notificationTypes.CLIENT_ACCOUNT_ACCESS_EXTENDED_IAP) {
      this.props.loadChat(notification.object_id_int);
    } else if (nt === notificationTypes.CLIENT_ACCOUNT_REACTIVATED_IAP) {
      this.props.loadChat(notification.object_id_int);
    } else if (
      nt === notificationTypes.IAP_EXPIRED_CLIENT_ACCOUNT_NOT_DEACTIVATED
    ) {
      this.props.goToClientSettings(
        notification.object_id_int,
        this.props.navigate,
      );
    }
  };
  renderRow = (notification, index) => {
    let backgroundColor = SelectedBackgroundColor;
    if (notification.read) {
      backgroundColor = "white";
    }
    let styles = {
      outer: {
        backgroundColor: backgroundColor,
      },
      container: {
        display: "flex",
        // flexDirection: "column",
        padding: "16px 20px",
        borderBottom: `1px solid ${primaryDark10}`,
        // alignItems: "center",
        cursor: "pointer",
      },
      profilePic: {
        // width: 30,
        // height: 30,
        marginRight: 16,
        alignItems: "flex-start",
      },
      content: {
        display: "flex",
        flexDirection: "column",
      },
      title: {
        fontSize: 14,
        lineHeight: "20px",
        fontWeight: 700,
      },
      details: {
        marginTop: 10,
        fontSize: 14,
        color: primaryDark,
        lineHeight: "20px",
        fontWeight: 500,
      },
      cta: {
        fontSize: 16,
        color: blue700,
      },
      trainerFuPP: {
        width: 40,
        height: 40,
        marginRight: 16,
      },
      ctaButton: {
        alignSelf: "flex-start",
        marginTop: 10,
      },
    };
    let profilePicView;
    let nt = notification.notification_type;
    if (
      nt === notificationTypes.TEST_DRIVE_CLIENT_APP ||
      nt === notificationTypes.TEST_DRIVE_MOBILE_APP ||
      nt === notificationTypes.TRAINERFU_ENGAGEMENT_MESSAGE
    ) {
      profilePicView = (
        <ProfileImageView
          photoUrl={require("../../img/logo4.png")}
          placeholderSize={40}
          size={40}
          style={styles.profilePic}
          circular={true}
        />
      );
    } else {
      profilePicView = (
        <ProfileImageView
          photoId={notification.user_photo_id}
          placeholderSize={40}
          size={40}
          style={styles.profilePic}
          circular={true}
        />
      );
    }
    let td = this.getTitleDetailsAndCta(notification);
    return (
      <div
        style={styles.outer}
        key={notification.id}
        onClick={() => {
          this.onNotificationClicked(notification);
        }}
      >
        <div style={styles.container} className={"hoverable"}>
          {profilePicView}
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <div style={styles.content}>
              <div style={styles.title}>{td.title}</div>
              {td.details !== null && (
                <div style={styles.details}>{td.details}</div>
              )}
              {td.cta !== null && (
                <Button
                  variant="contained"
                  color="primary"
                  style={styles.ctaButton}
                >
                  {td.cta}
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };
  noNotificatonView = () => {
    let styles = {
      container: {
        border: `5px dashed ${primaryDark10}`,
        height: 90,
        display: "flex",
        flex: "1 1 auto",
        flexDirection: "column",
      },
      title: {
        marginLeft: "auto",
        marginRight: "auto",
        flex: "1 1 auto",
        fontSize: 20,
        marginTop: 30,
        color: grey600,
      },
    };
    return (
      <div style={styles.container}>
        <div style={styles.title}>{t("noNotifications")}</div>
      </div>
    );
  };
  render = () => {
    let styles = {
      outer: {
        width: 400,
        minHeight: 100,
        maxHeight: 500,
        overflow: "scroll",
        border: `1px solid ${primaryDark10}`,
      },
      container: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        backgroundColor: "white",
      },
    };
    let inner;
    if (this.props.notifications === null) {
      inner = <div />;
    } else if (this.props.notifications.length === 0) {
      inner = this.noNotificatonView();
    } else {
      inner = [];
      for (let i = 0; i < this.props.notifications.length; i++) {
        inner.push(this.renderRow(this.props.notifications[i], i));
      }
    }
    return (
      <div style={styles.outer}>
        <div style={styles.container}>{inner}</div>
      </div>
    );
  };
  getTitleDetailsAndCta = (notification) => {
    let nt = notification.notification_type;
    let title = "";
    let details = null;
    let cta = null;
    let meta = notification.meta;
    let name = "";
    let firstName = "";
    let lastName = "";
    if (meta) {
      firstName = meta.first_name;
      lastName = meta.last_name;
      title = meta.title;
      name = meta.name;
    }
    switch (nt) {
      case notificationTypes.NEW_MESSAGE: {
        title = t("youHaveReceivedANewMessageFromFirstname", { firstName });
        break;
      }
      case notificationTypes.STORY_LIKED: {
        let st = meta.story_type;
        if (st === storyTypes.POST) {
          title = t("firstnameLikesYourPost", { firstName });
        } else if (st === storyTypes.LINK) {
          title = t("firstnameLikesThePageYouShared", { firstName });
        }
        break;
      }
      case notificationTypes.STORY_COMMENT_ADDED: {
        let st = meta.story_type;
        let ownedBySelf = meta.owned_by_self;
        if (ownedBySelf) {
          if (st === storyTypes.POST) {
            title = t("firstnameAddedACommentToYourPost", { firstName });
          } else if (st === storyTypes.LINK) {
            title = t("firstnameAddedACommentToThePageYouShared", [firstName]);
          }
        } else {
          if (st === storyTypes.WORKOUT_LOG) {
            title = t("firstnameAlsoAddedACommentToFirstnameSWorkout", {
              firstName,
            });
          } else if (st === storyTypes.ASSESSMENT) {
            title = t("firstnameAlsoAddedACommentToFirstnameSAssessment", {
              firstName,
            });
          } else if (st === storyTypes.MEAL_LOG) {
            title = t("firstnameAlsoAddedACommentToFirstnameSMeal", {
              firstName,
            });
          } else if (st === storyTypes.PROGRESS_PHOTO) {
            title = t("firstnameAlsoAddedACommentToFirstnameSProgressPhoto", {
              firstName,
            });
          } else if (st === storyTypes.POST) {
            title = t("firstnameAlsoAddedACommentToFirstnameSPost", {
              firstName,
            });
          } else if (st === storyTypes.LINK) {
            title = t("firstnameAlsoAddedACommentToThePageFirstnameSShared", {
              firstName,
            });
          } else if (st === storyTypes.CHECKIN) {
            title = t("firstnameAlsoAddedACommentToFirstnameSCheckin", {
              firstName,
            });
          }
        }
        break;
      }
      case notificationTypes.CLIENT_IGNORED_INVITE: {
        title = t("reSendInviteToFirstname", { firstName });
        details = t(
          "youRecentlySentAnInviteToFirstnameButItLooksLikeTheyStillHaventDownloadedTheAppYetReSendInvite",
          { firstName },
        );
        break;
      }
      case notificationTypes.CLIENT_FIRST_LOGIN: {
        title = t("congratsFirstnameStartedUsingTheApp", { firstName });
        if (meta.waiting_for_workout_plan) {
          details = t(
            "alertLooksLikeFirstnameDoesNotHaveAWorkoutPlanReadyStartBuildingPlanForFirstname",
            { firstName },
          );
        } else {
          details = t("sendFirstnameAPersonalMessage", { firstName });
        }
        break;
      }
      case notificationTypes.TEST_DRIVE_MOBILE_APP: {
        title = t("trainerfuForIosAndAndroid");
        details = t(
          "downloadTheFreeTrainerfuAppOnYourIphoneIpadOrAndroidDeviceAndBeProductiveEverywhere",
        );
        cta = t("learnMore");
        break;
      }
      case notificationTypes.TEST_DRIVE_CLIENT_APP: {
        title = t("trainerfuClientApp");
        details = t(
          "yourClientsCanDownloadTheFreeMobileAppToSeeTheirPlanTrackWorkoutAndMore",
        );
        cta = t("testDriveTheClientApp");
        break;
      }
      case notificationTypes.NEW_CLIENT_SIGNUP: {
        title = meta.title;
        let refName = meta.ref_name;
        if(refName) {
          details = t("firstnameLastnameSignedUpForTitleRefName", {
            firstName,
            lastName,
            title,
            refName
          });
        } else {
          details = t("firstnameLastnameSignedUpForTitleSayHi", {
            firstName,
            lastName,
            title,
          });
        }
        
        break;
      }
      case notificationTypes.TRAINERFU_ENGAGEMENT_MESSAGE: {
        title = t(meta.title);
        details = t(meta.detail);
        break;
      }
      case notificationTypes.GMAIL_API_TOKEN_EXPIRED: {
        title = t("emailDeliveryFailedYourGmailIntegrationIsInvalidOrExpired");
        details = t(
          "toStartSendingEmailsAgainGoToYourIntegrationViewAndReIntegrateWithGmail",
        );
        cta = "Re-Integrate";
        break;
      }
      case notificationTypes.CLIENT_CANCELLED_SUBSCRIPTION: {
        title = t("firstnameCancelledTheirSubscription", { firstName });
        details = meta.title ? t("packageNameTitle", { title }) : null;
        break;
      }
      case notificationTypes.PLAN_TEMPLATE_COPIED: {
        title = t("completedCopyingOfNameTemplate", { name });
        break;
      }
      case notificationTypes.DELETE_CLIENT_ACCOUNT_REQUEST: {
        title = t("firstnameHasRequestedToDeleteTheirAccount", { firstName });
        details = t(
          "theirAccountIsDeactivatedPleaseDeleteTheirAccountInTheNext_48Hours",
        );
        break;
      }
      case notificationTypes.CLIENT_ACCOUNT_DEACTIVATED_IAP: {
        title = t("firstnameSAccountIsDeactivated", { firstName });
        details = t("thisHappenedBecauseTheirInAppPurchaseHasExpired");
        break;
      }
      case notificationTypes.CLIENT_ACCOUNT_ACCESS_EXTENDED_IAP: {
        title = t("firstnamePurchasedAnotherInAppPackage", { firstName });
        details = t("firstnameSSubscriptionToTheAppIsExtendedBy_30Days", {
          firstName,
        });
        break;
      }
      case notificationTypes.CLIENT_ACCOUNT_REACTIVATED_IAP: {
        title = t("firstnamePurchasedAnotherInAppPackage-0", { firstName });
        details = t("firstnameSAccountIsReactivated", { firstName });
        break;
      }
      case notificationTypes.IAP_EXPIRED_CLIENT_ACCOUNT_NOT_DEACTIVATED: {
        title = t("firstnameSInAppPurchaseHasExpired", { firstName });
        details = t(
          "firstnameSAccountIsNotDeactivatedBecauseTheyRecentlyBoughtAPackageLinkedToStripe",
          { firstName },
        );
        break;
      }
    }
    return {
      title: title,
      details: details,
      cta: cta,
    };
  };
}
const mapStateToProps = (state, ownProps) => {
  return {
    notifications: state.notifications,
    newNotificationsCount: state.newNotificationsCount,
    clients: state.clients,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getNotifications: () => {
      dispatch({
        type: GET_NOTIFICATIONS.REQUEST,
      });
    },
    recordReadNotification: (notification) => {
      dispatch({
        type: MARK_NOTIFICATION_READ.REQUEST,
        payload: {
          notification: notification,
        },
      });
    },
    loadStory: (storyId, navigate) => {
      navigate(`/stories/${storyId}`);
    },
    testDriveClientApp: (navigate) => {
      navigate("/posts/test-drive-client-app");
    },
    testDriveMobileApp: (navigate) => {
      navigate("/posts/trainerfu-for-ios-and-android");
    },
    goToIntegrationSettings: (navigate) => {
      navigate("/settings/integrations");
    },
    goToClientSettings: (clientId, navigate) => {
      navigate(`/clients/${clientId}/settings`);
    },
    loadChat: (clientId) => {
      dispatch(
        updateChatState({
          channelType: channelTypes.CHAT,
          isOpen: true,
          clientId: clientId,
        }),
      );
    },
    loadClient: (clientId, navigate) => {
      navigate(`/clients/${clientId}/programs`);
    },
    loadPlanTemplate: (planTemplateId, navigate) => {
      navigate(`/plan-templates/${planTemplateId}`);
    },
    getClients: () => {
      dispatch({
        type: GET_CLIENTS.REQUEST,
      });
    },
  };
};

const NotificationsViewWithRouter = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  return (
    <NotificationsView {...props} location={location} navigate={navigate} />
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(NotificationsViewWithRouter);
